import React from 'react';
import IconSvg from 'Components/IconSvg';

const Toast = ({ onDismiss, toast = {} }) => {
  const handleDismiss = () => onDismiss(toast.id);
  return (
    <div className="toaster__toast" onClick={handleDismiss}>
      <IconSvg type="error" />
      <span>{toast.message}</span>
    </div>
  );
};

export default Toast;
